// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__xwoDA","actionsCol":"EnrolledClinics_actionsCol__ULmsZ"};